import styled, { keyframes } from 'styled-components';
import basic from '../../../assets/image/jobs/리쿠.png';
import firefighter from '../../../assets/image/jobs/소방관.png';
import policeman from '../../../assets/image/jobs/경찰관.png';
import doctor from '../../../assets/image/jobs/의사.png';
import nurse from '../../../assets/image/jobs/간호사.png';
import environment from '../../../assets/image/jobs/환경지킴이.png';
import teacher from '../../../assets/image/jobs/선생님.png';
import astronomer from '../../../assets/image/jobs/천문학자.png';
import cook from '../../../assets/image/jobs/요리사.png';

export {
	basic,
	firefighter,
	policeman,
	doctor,
	nurse,
	environment,
	teacher,
	astronomer,
	cook,
};

const fadeIn = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

const slideIn = keyframes`
	from {
		transform: translateY(-50px);
		opacity: 0;
	}
	to {
		transform: translateY(0);
		opacity: 1;
	}
`;

export const Container = styled.div`
	width: 100%;
	height: 100%;
`;
export const ModalBackground = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	animation: ${fadeIn} 0.3s ease;
`;

export const ModalContainer = styled.div`
	position: relative;
	width: 85%;
	max-width: 800px;
	background-color: white;
	border-radius: 15px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
	overflow: hidden;
	animation: ${slideIn} 0.4s ease;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 15px;
	right: 15px;
	background: none;
	border: none;
	font-size: 24px;
	cursor: pointer;
	color: #666;
	z-index: 10;

	&:hover {
		color: #333;
	}
`;

export const ModalContent = styled.div`
	display: flex;
	flex-direction: row;

	@media (max-width: 768px) {
		flex-direction: column;
	}
`;

export const ImageSection = styled.div`
	flex: 0 0 40%;
	background-color: #f8f9fa;
	padding: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const PersonaImage = styled.img`
	max-width: 100%;
	max-height: 300px;
	object-fit: contain;
	border-radius: 10px;
`;

export const InfoSection = styled.div`
	flex: 0 0 60%;
	padding: 30px;
`;

export const Title = styled.h2`
	font-size: 28px;
	font-weight: bold;
	margin-bottom: 10px;
	color: #333;
`;

export const SubTitle = styled.p`
	font-size: 16px;
	color: #666;
	margin-bottom: 25px;
	line-height: 1.5;
`;

export const DetailsList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0 0 25px 0;
`;

export const DetailItem = styled.li`
	display: flex;
	margin-bottom: 12px;
	align-items: flex-start;
`;

export const DetailIcon = styled.span`
	color: #4caf50;
	font-size: 18px;
	margin-right: 10px;
	font-weight: bold;
`;

export const DetailText = styled.span`
	font-size: 15px;
	color: #444;
	line-height: 1.5;
`;

export const ApplyButton = styled.button`
	background-color: #3498db;
	color: white;
	border: none;
	border-radius: 30px;
	padding: 12px 24px;
	font-size: 16px;
	font-weight: bold;
	cursor: pointer;
	transition: all 0.3s ease;
	box-shadow: 0 4px 6px rgba(52, 152, 219, 0.3);

	&:hover {
		background-color: #2980b9;
		transform: translateY(-3px);
		box-shadow: 0 6px 8px rgba(52, 152, 219, 0.4);
	}

	&:active {
		transform: translateY(0);
		box-shadow: 0 2px 4px rgba(52, 152, 219, 0.4);
	}
`;

export const AppliedMessage = styled.span`
	font-size: 15px;
	color: green;
	line-height: 1.5;
`;
